import {
  BankAccountClosureReason,
  InvestmentAccountClosureReason,
  TierSubscriptionDeactivationReason,
} from 'generated/types'
import React, { createContext, useContext, useState } from 'react'

export type ClosureReason =
  | TierSubscriptionDeactivationReason
  | BankAccountClosureReason
  | InvestmentAccountClosureReason

export enum ClosureContextOptions {
  singleAccountClosure,
  downgrade,
  cancelSubscription,
}

type ClosureContextType = {
  closureContext?: ClosureContextOptions
  setClosureContext: (closureContext?: ClosureContextOptions) => void
}

export const ClosureContext = createContext<ClosureContextType>({
  closureContext: undefined,
  setClosureContext: () => null,
})

type Props = {
  children: React.ReactNode
}

export const ClosureContextProvider = ({ children }: Props) => {
  const [closureContext, setClosureContext] = useState<
    ClosureContextOptions | undefined
  >(undefined)

  return (
    <ClosureContext.Provider
      value={{
        closureContext,
        setClosureContext,
      }}
    >
      {children}
    </ClosureContext.Provider>
  )
}

export const useClosureContextProvider = () => {
  const { closureContext, setClosureContext } = useContext(ClosureContext)
  return { closureContext, setClosureContext }
}
